import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useRouteMatch } from 'react-router-dom';
import { Form, Modal } from 'antd';

import SubgroupForm from '../SubgroupForm';
import {
  SubGroupByGroup,
  UpdateSubGroupRequest,
} from '@/core/domain/operational/SubGroups/SubGroups.types';
import { useUpdateSubGroup } from '@/core/domain/operational/SubGroups/SubGroups.hooks';

interface Props {
  visible: boolean;
  handleVisible: (subgroup?: SubGroupByGroup) => void;
  subgroup?: SubGroupByGroup;
}

const UpdateSubgroupModal = ({ visible, handleVisible, subgroup }: Props) => {
  const intl = useIntl();
  const [form] = Form.useForm();
  const { groupId } = useRouteMatch<{ groupId: string }>().params;

  useEffect(() => {
    if (visible && subgroup) {
      form.setFieldsValue({
        name: subgroup.name,
      });
    }
  }, [visible, subgroup]);

  const updatemutation = useUpdateSubGroup();

  const handleOk = async () => {
    try {
      if (subgroup) {
        const values = await form.validateFields();

        const obj: UpdateSubGroupRequest = {
          ...values,
          groupId,
          id: subgroup.id,
        };

        await updatemutation.mutateAsync(obj);

        form.resetFields();

        handleCancel();
      }
    } catch {}
  };

  const handleCancel = () => {
    handleVisible(subgroup);
  };

  return (
    <Modal
      title={intl.formatMessage({ id: 'groups.subgroups.update' })}
      open={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={updatemutation.isLoading}
    >
      <SubgroupForm form={form} />
    </Modal>
  );
};

export default UpdateSubgroupModal;
